<template>
    <section class="gh-section gh-suicide-prevention__requirement" id="ce-credits">
        <div class="container">
            <div class="gh-content">
                <h2 class="gh-section-heading">
                    Contribute to your annual CPD requirements
                </h2>
                <div class="gh-section-body">
                    <p>Continuing Professional Development (CPD) is a mandatory requirement for most mental health member associations and credentialing bodies. Registered attendees of the 2022 Suicide Prevention Summit will gain access to personalised CPD Certificates for each session they attend.</p>
                    <p>Some of the mental health professionals who may be able to accrue CPD include:</p>
                    <el-row class="gh-prof-list">
                        <el-col class="gh-list-item"> <i class="fa fa-check-circle"></i>  Psychologists </el-col>
                        <el-col class="gh-list-item"> <i class="fa fa-check-circle"></i>  Counsellors </el-col>
                        <el-col class="gh-list-item"> <i class="fa fa-check-circle"></i>  Mental Health Nurses </el-col>
                        <el-col class="gh-list-item"> <i class="fa fa-check-circle"></i>  Social Workers </el-col>
                    </el-row>
                    <p>To check your requirements and eligibility for CPD hours/points, please contact your professional Association.</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        styles: {
            type: Object,
            default: () => {backgroundColor: '#F3F3F3' }
        }
    }
}
</script>

<style scoped lang="scss">
    .gh-suicide-prevention__requirement {
        background-color: #F0F1F2;
        font-family: proxima-nova,sans-serif;
        p {
            color: #2c3138;
        }
    }

    .gh-section-heading {
        text-align: left;
        margin-bottom: 20px;
        line-height: 1;
        font-weight: 600;
        font-size: 2.4rem;
        color: #001e41;
        padding-bottom: 0;
    }

    .s-logo {
        display: none;
        width: 350px;
    }
    .gh-content {
        max-width: 700px;
      font-weight: 500;
        .gh-section-body {
            p {
                font-size: 1.17rem;
                line-height: 1.5;
                + p {
                    margin-top: 1rem;
                }
            }
        }
    }

    .gh-prof-list {
        margin-bottom: 1rem;
        .gh-list-item {
            font-size: 1.2rem;
            color: #2c3138;
            padding-top: 1rem;
            i {
                margin-right: .5rem;
            }
        }
    }

    @media screen and (min-width: '769px') {
        .s-logo {
            display: block;
        }
    }


    @media screen and (min-width: '64em') {
        .gh-suicide-prevention__requirement {
            background-image: url("/images/suicidePreventionSummit/certificate-mockup-CPD-sps-2021.png");
            background-repeat: no-repeat;
            background-position: right calc((100vw - 78em) / 2) bottom -2px !important;
            background-size: 490px;
        }
    }
</style>
